
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/didattica/[slug]",
      function () {
        return require("private-next-pages/didattica/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/didattica/[slug]"])
      });
    }
  